import React from 'react';
import WysiwygContent from 'shared/components/WysiwygContent';
import { textPublicPropTypes } from 'shared/proptypes/ContentModule';

const ContentModuleViewText = ({ title, text }) => (
  <>
    {title && (<h2>{title}</h2>)}
    <WysiwygContent>{text}</WysiwygContent>
  </>
);

ContentModuleViewText.propTypes = textPublicPropTypes;

export default ContentModuleViewText;
